const amountOfClientsOnPage = 20;

export default amountOfClientsOnPage;
